// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import RichTextBlock from '../../ev-rich-text-block'
import { Icon } from '../../../atoms'
import { useEntities } from '../../helpers/selectors'
import StatSnippet from '../stat-snippet'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import { richTextBlockStyleByBrand, moneyQuoteStyles, uswitchQuoteStyles } from './styles'

const SingleColumnRichText = (props) => {
  let {
    content: document,
    contentPosition = 'left',
    heading = undefined,
    brand,
    name,
    variant,
  } = props
  let blockquote
  let statSnipet

  if (document) {
    const { content } = document
    let newContent = JSON.parse(JSON.stringify(content))

    blockquote = content
      .slice()
      .reverse()
      .find((c) => c.nodeType === 'blockquote')

    if (blockquote) {
      newContent = newContent.filter((c) => c.nodeType !== 'blockquote')
    }

    const embededEntries = content.filter((c) => c.nodeType === 'embedded-entry-block')
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entries = useEntities(embededEntries.map((e) => e.data.target))
    statSnipet = entries.find((c) => c.variant === 'stat-snippet')

    if (statSnipet) {
      newContent = newContent.filter((c) => c?.data?.target?.sys?.id !== statSnipet.sys.id)
    }

    document = { ...document, content: newContent }
  }
  return (
    <div className='SingleColumnRichTextNew' id={removeWhitespaceAndSpecialChars(name)}>
      {heading && (
        <RichTextBlock {...props} content={heading} style={richTextBlockStyleByBrand(brand)} />
      )}
      {contentPosition === 'left' && (
        <div className='SingleColumnRichTextNew__container'>
          <div className='SingleColumnRichTextNew__container__columnOne'>
            <RichTextBlock
              {...props}
              content={document}
              style={richTextBlockStyleByBrand(brand)}
              customVaraint={variant === 'with-badge' ? `content-${variant}` : variant}
            />
          </div>
          <div className='SingleColumnRichTextNew__container__columnTwo'>
            {(blockquote || statSnipet) && (
              <div>
                {blockquote && (
                  <div className='SingleColumnRichTextNew__container__columnTwo__quote'>
                    <div>
                      <Icon
                        glyph={'quotemarks-stroke'}
                        size={45}
                        desktopSize={65}
                        color='#34454E'
                      />
                      <RichTextBlock
                        {...props}
                        content={blockquote}
                        style={brand === 'money' ? moneyQuoteStyles : uswitchQuoteStyles}
                      />
                    </div>
                  </div>
                )}
                {statSnipet && <StatSnippet {...statSnipet} />}
              </div>
            )}
          </div>
        </div>
      )}
      {contentPosition === 'right' && (
        <div className='SingleColumnRichTextNew__container'>
          <div className='SingleColumnRichTextNew__container__columnOne' />
          <div className='SingleColumnRichTextNew__container__columnTwo'>
            <RichTextBlock
              {...props}
              content={document}
              style={richTextBlockStyleByBrand(brand)}
              customVaraint={variant === 'with-badge' ? `content-${variant}` : variant}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default SingleColumnRichText
